import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";

/**
 * QA-FINAL-02 — Visible Logout fallback route.
 * Used when the ProfileMenu trigger is unreachable (z-index conflict,
 * overlay collision, automated-tap failure). Performs the same cleanup
 * as ProfileMenu.handleLogout and hard-redirects to /welcome.
 */
export const Route = createFileRoute("/logout")({
  ssr: false,
  head: () => ({ meta: [{ title: "Cerrando sesión · VerseSport™" }] }),
  component: LogoutPage,
});

function LogoutPage() {
  const { logout } = useAuth();
  useEffect(() => {
    (async () => {
      try { await logout(); } catch { /* ignore */ }
      try {
        for (const k of ["ss2026_registered", "ss2026_session_id", "ss2026_role"]) {
          window.localStorage.removeItem(k);
        }
      } catch { /* ignore */ }
      window.location.replace("/welcome");
    })();
  }, [logout]);
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
      <div className="max-w-sm space-y-3">
        <h1 className="text-xl font-black">Cerrando sesión…</h1>
        <p className="text-sm text-muted-foreground">
          Si no eres redirigido en unos segundos,
          {" "}
          <a href="/welcome" className="font-bold text-primary underline">
            vuelve al inicio
          </a>.
        </p>
      </div>
    </main>
  );
}